/* eslint camelcase: 0 */

import { NotificationBanner as Data } from '@/typings/api/NotificationBanner'
import { Model, createMessages } from '@/helpers/Model'


export class ParticipantsModel extends Model<Data> {
  public static readonly page_title = createMessages({
    ...Model.page_title,
    create: 'Добавить участника',
    edit: 'Редактировать участника',
    view: (data: ParticipantsModel) => 'Участник «{name}»'
      .replace('{name}', data.name || '...'),
    list: 'Участники',
  });

  public static readonly modal_delete = createMessages({
    ...Model.modal_delete,
    delete: (data: ParticipantsModel) => 'Удаление участника «{name}»'
      .replace('{name}', data.name || '...'),
  });
}
